import {
    APP_SUMO_PAGE,
    BILLING_PAGE_TAB,
    EVENTS_PAGE_TAB,
    SETTINGS_TAB,
    TEAM_PAGE_TAB,
    VIDEO_LIBRARY_PAGE_TAB,
    GETTING_STARTED_TAB,
    HELP_PAGE_TAB,
} from 'components/community/constants';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import history from '../../history';

function useCommunitySideMenu() {
    const communityData = useSelector((state) => state.Community);
    const user = useSelector((state) => state.auth.user);
    const isCommunityManager = user?.id === communityData?.current?.manager_id;

    const sideMenuConfig = useMemo(() => {
        return {
            [GETTING_STARTED_TAB]: {
                id: 'getting-started',
                disabled: !communityData?.current?.show_getting_started,
                isSvg: true,
                displayText: 'Getting Started',
                icon: 'icon-rocket',
            },
            [EVENTS_PAGE_TAB]: {
                id: 'airmeets',
                disabled: false,
                isSvg: true,
                displayText: 'Events',
                icon: 'icon-airmeet',
            },
            [VIDEO_LIBRARY_PAGE_TAB]: {
                id: 'videoLibrary',
                disabled: false,
                isSvg: false,
                displayText: 'Video Library',
                icon: 'video',
            },
            [TEAM_PAGE_TAB]: {
                id: 'team',
                disabled: false,
                isSvg: true,
                displayText: 'Team',
                icon: 'icon-members',
            },
            [SETTINGS_TAB]: {
                id: 'integration',
                disabled: false,
                isSvg: true,
                displayText: 'Integrations',
                icon: 'icon-integration',
            },
            [BILLING_PAGE_TAB]: {
                id: 'billing-plans',
                disabled: communityData?.current?.coupon_type ? true : false,
                isSvg: false,
                displayText: 'Billing plans',
                icon: 'billing-plans',
            },
            [APP_SUMO_PAGE]: {
                id: 'appSumoPlans',
                disabled:
                    communityData?.current?.coupon_type && isCommunityManager
                        ? false
                        : true,
                isSvg: false,
                displayText: 'AppSumo Plan',
                icon: 'plan_badge',
            },
            [HELP_PAGE_TAB]: {
                id: 'get-help',
                disabled: !!communityData?.current?.show_getting_started,
                isSvg: true,
                displayText: 'Help Center',
                icon: 'help_circle',
            },
        };
    }, [communityData, communityData?.current?.communityId]);

    const menuSwitcherHandler = (menuName) => {
        history.push(
            `/community-manager/${communityData?.current?.communityId}/${menuName}`
        );
    };

    return { sideMenuConfig, menuSwitcherHandler };
}

export default useCommunitySideMenu;
